// components/ProductComponent.js
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { RestaurantList } from './RestaurantList'
import { MenuList } from './MenuList'
import { ArrowBack } from '@mui/icons-material'
import './RestaurantStyle.css'

export const ProductComponent = () => {
  const [selectedRestaurant, setSelectedRestaurant] = useState(null)
  const [filteredRestaurants, setFilteredRestaurants] = useState([])
  const [searchedText, setSearchedText] = useState('')

  const handleGoBack = () => {
    setSelectedRestaurant(null)
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          process.env.REACT_APP_API_URL + '/restaurantsGeo',
          {
            filter: {},
            source: 3
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )

        const processedData = response.data.data.map(restaurant => {
          if (restaurant.logo) {
            restaurant.logo = `https://haproxy.abspos.pl/media/${restaurant.logo}`
          }
          return restaurant
        })

        setFilteredRestaurants(processedData)
      } catch (error) {
        console.error('Error fetching', error)
      }
    }

    fetchData()
  }, [])

  const handleSearch = text => {
    const lowerCaseText = text.toLowerCase()
    const filtered = filteredRestaurants.filter(restaurant => restaurant.name.toLowerCase().includes(lowerCaseText))

    setSearchedText(text)
    setSelectedRestaurant(null)
    setFilteredRestaurants(filtered)
  }

  return (
    <div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '10px'
        }}
      >
        {selectedRestaurant && (
          <button
            onClick={handleGoBack}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              marginRight: '8px'
            }}
          >
            <ArrowBack />
          </button>
        )}
        <h1
          style={{
            fontFamily: 'Poppins',
            fontSize: '28px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: 'normal',
            margin: 0
          }}
        >
          Program lojalnościowy
        </h1>
      </div>

      {selectedRestaurant ? (
        <MenuList selectedRestaurant={selectedRestaurant} goBack={handleGoBack} />
      ) : (
        <RestaurantList setSelectedRestaurant={setSelectedRestaurant} />
      )}
    </div>
  )
}
